const API_URL = 'http://localhost:3001/api/email';

/**
 * Envía un email con múltiples archivos adjuntos
 * @param {Object} params - Parámetros del email
 * @param {string} params.destinatario - Email del destinatario
 * @param {string} params.asunto - Asunto del email
 * @param {string} params.mensaje - Cuerpo del mensaje
 * @param {Array} params.adjuntos - Array de objetos {blob, nombre}
 */
export async function enviarEmailConAdjuntos({ destinatario, asunto, mensaje, adjuntos = [] }) {
  try {
    console.log('📧 Enviando email a:', destinatario);
    console.log('📎 Adjuntos:', adjuntos.length);
    
    const formData = new FormData();
    formData.append('destinatario', destinatario);
    formData.append('asunto', asunto);
    formData.append('mensaje', mensaje);
    
    // Añadir archivos adjuntos
    for (const adjunto of adjuntos) {
      formData.append('adjuntos', adjunto.blob, adjunto.nombre);
    }
    
    const response = await fetch(`${API_URL}/enviar`, {
      method: 'POST',
      body: formData
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error);
    }
    
    console.log('✅ Email enviado correctamente');
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error enviando email:', error);
    throw error;
  }
}

/**
 * Envía facturas a la gestoría con Excel y PDF
 * @param {Array} facturas - Array de facturas
 * @param {Object} archivos - Objeto con blobs de excel y pdf
 * @param {string} emailGestoria - Email de la gestoría
 */
export async function enviarFacturasAGestoria(facturas, archivos, emailGestoria) {
  if (!emailGestoria) {
    throw new Error('No hay email de gestoría configurado. Ve a Configuración para establecerlo.');
  }
  
  try {
    console.log('📊 Enviando facturas a gestoría...');
    console.log('Total facturas:', facturas.length);
    console.log('Archivos recibidos:', archivos);
    
    // Validar que los archivos sean Blobs válidos
    if (!archivos.excel || !(archivos.excel instanceof Blob)) {
      throw new Error('El archivo Excel no es válido o no existe');
    }
    
    if (!archivos.pdf || !(archivos.pdf instanceof Blob)) {
      throw new Error('El archivo PDF no es válido o no existe');
    }
    
    const formData = new FormData();
    formData.append('factura_ids', JSON.stringify(facturas.map(f => f.id)));
    formData.append('email_gestoria', emailGestoria);
    
    // Crear archivos File desde los Blobs (más compatible)
    const excelFile = new File([archivos.excel], archivos.nombreExcel, {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const pdfFile = new File([archivos.pdf], archivos.nombrePdf, {
      type: 'application/pdf'
    });
    
    formData.append('excel', excelFile);
    formData.append('pdf', pdfFile);
    
    const response = await fetch(`${API_URL}/enviar-gestoria`, {
      method: 'POST',
      body: formData
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error);
    }
    
    console.log(`✅ ${facturas.length} facturas enviadas a gestoría`);
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error enviando facturas a gestoría:', error);
    console.error('Detalles del error:', error.message);
    throw error;
  }
}

/**
 * Envía una factura individual a un cliente
 * @param {Object} factura - Factura a enviar
 * @param {Blob} pdfBlob - PDF de la factura
 */
export async function enviarFacturaACliente(factura, pdfBlob) {
  if (!factura.cliente_email) {
    throw new Error('El cliente no tiene email configurado');
  }
  
  try {
    console.log('👤 Enviando factura a cliente:', factura.cliente_nombre);
    
    // Validar que el PDF sea un Blob válido
    if (!pdfBlob || !(pdfBlob instanceof Blob)) {
      throw new Error('El archivo PDF no es válido o no existe');
    }
    
    const formData = new FormData();
    formData.append('factura_id', factura.id);
    
    // Crear archivo File desde el Blob
    const pdfFile = new File([pdfBlob], `factura-${factura.serie}-${factura.numero}.pdf`, {
      type: 'application/pdf'
    });
    
    formData.append('pdf', pdfFile);
    
    const response = await fetch(`${API_URL}/enviar-cliente`, {
      method: 'POST',
      body: formData
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error);
    }
    
    console.log(`✅ Factura ${factura.serie}-${factura.numero} enviada a cliente`);
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error enviando factura a cliente:', error);
    console.error('Detalles del error:', error.message);
    throw error;
  }
}